// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import request from '@/api/request';

/**
 * @description 验证码
 */
export function captchaApi() {
  return request({
    url: 'captcha',
    method: 'get',
  });
}

/**
 * @description 登录
 */
export function login(data: any) {
  return request({
    url: 'login',
    method: 'post',
    data,
  });
}

/**
 * @description 登录页配置
 */
export function loginConfigApi() {
  return request({
    url: 'login_config',
    method: 'get',
  });
}

/**
 * @description 退出登录
 */
export function logout() {
  return request({
    url: 'logout',
    method: 'get',
  });
}

/**
 * @description 当前管理员 profile（含按钮 access，对齐 mer/info）
 */
export function getBaseInfo(params?: { circleId?: number }) {
  return request({
    url: 'profile',
    method: 'get',
    params,
  });
}

/**
 * @description 修改密码
 */
export function passwordFormApi() {
  return request({
    url: 'system/admin/edit/password/form',
    method: 'get',
  });
}

/**
 * @description 修改自己的信息
 */
export function editFormApi() {
  return request({
    url: 'system/admin/edit/form',
    method: 'get',
  });
}

/**
 * @description 菜单
 */
export function getMenusApi(params:any) {
  return request({
    url: 'menus',
    method: 'get',
      params: params,
  });
}

/**
 * @description 创建用户
 */
export function createUserApi() {
  return request({
    url: 'user/create',
    method: 'get',
  });
}

/**
 * @description 添加新用户
 */
export function addUserApi(data: any) {
  return request({
    url: 'user/create',
    method: 'post',
    data,
  });
}

/**
 * @description 用户分组 -- 编辑表单
 */
export function groupEditApi(id: number | string) {
  return request({
    url: `user/group/form/${id}`,
    method: 'get',
  });
}

/**
 * @description 用户分组 -- 添加表单
 */
export function groupFormApi() {
  return request({
    url: 'user/group/form',
    method: 'get',
  });
}

/**
 * @description 用户分组 -- 列表
 */
export function groupLstApi(data: any) {
  return request({
    url: 'user/group/lst',
    method: 'get',
    params: data,
  });
}

/**
 * @description 用户分组 -- 删除
 */
export function groupDeleteApi(id: number | string) {
  return request({
    url: `user/group/${id}`,
    method: 'delete',
  });
}

/**
 * @description 用户标签 -- 编辑表单
 */
export function labelEditApi(id: number | string) {
  return request({
    url: `user/label/form/${id}`,
    method: 'get',
  });
}

/**
 * @description 用户标签 -- 添加表单
 */
export function labelFormApi() {
  return request({
    url: 'user/label/form',
    method: 'get',
  });
}

/**
 * @description 用户标签 -- 列表
 */
export function labelLstApi(data: any) {
  return request({
    url: 'user/label/lst',
    method: 'get',
    params: data,
  });
}

/**
 * @description 用户标签 -- 删除
 */
export function labelDeleteApi(id: number | string) {
  return request({
    url: `user/label/${id}`,
    method: 'delete',
  });
}

/**
 * @description 用户列表 -- 列表
 */
export function userLstApi(data: any) {
  return request({
    url: 'user/lst',
    method: 'post',
    data,
  });
}

/**
 * @description 用户列表 -- 设置分组
 */
export function changeGroupApi(id: number | string) {
  return request({
    url: `user/change_group/form/${id}`,
    method: 'get',
  });
}

/**
 * @description 用户列表 -- 设置标签
 */
export function changelabelApi(id: number | string) {
  return request({
    url: `user/change_label/form/${id}`,
    method: 'get',
  });
}

/**
 * @description 用户列表 -- 编辑会员等级
 */
export function changeMemberApi(id: number | string) {
  return request({
    url: `user/member/${id}/form`,
    method: 'get',
  });
}

/**
 * @description 用户列表 -- 修改余额
 */
export function changeNowMoneyApi(id: number | string) {
  return request({
    url: `user/change_now_money/form/${id}`,
    method: 'get',
  });
}

/**
 * @description 用户列表 -- 修改积分
 */
export function changeNowIntegralApi(id: number | string) {
  return request({
    url: `user/change_integral/form/${id}`,
    method: 'get',
  });
}

/**
 * @description 用户列表 -- 批量设置分组
 */
export function batchChangeGroupApi(data: any) {
  return request({
    url: 'user/batch_change_group/form',
    method: 'get',
    params: data,
  });
}

/**
 * @description 用户列表 -- 设置分销员
 */
export function changePrommoterApi(data: any) {
  return request({
    url: 'user/batch_spread_form',
    method: 'get',
    params: data,
  });
}

/**
 * @description 用户列表 -- 批量设置标签
 */
export function batchChangelabelApi(data: any) {
  return request({
    url: 'user/batch_change_label/form',
    method: 'get',
    params: data,
  });
}

/**
 * @description 用户列表 -- 编辑用户
 */
export function userUpdateApi(id: number | string) {
  return request({
    url: `user/update/form/${id}`,
    method: 'get',
  });
}

/**
 * @description 用户列表 -- 修改密码
 */
export function modifyUserPassword(id: number | string) {
  return request({
    url: `user/change_password/form/${id}`,
    method: 'get',
  });
}

/**
 * @description 用户列表 -- 发送图文消息
 */
export function userNewsApi(data: any) {
  return request({
    url: 'user/news/push',
    method: 'post',
    data,
  });
}

/**
 * @description 用户 -- 详情头部
 */
export function userDetailApi(uid: number | string) {
  return request({
    url: `user/detail/${uid}`,
    method: 'get',
  });
}

/**
 * @description 用户 -- 详情消费记录
 */
export function userOrderApi(uid: number | string, data: any) {
  return request({
    url: `user/order/${uid}`,
    method: 'get',
    params: data,
  });
}

/**
 * @description 用户 -- 积分记录
 */
export function userPointsApi(uid: number | string, data: any) {
  return request({
    url: `user/integral/${uid}`,
    method: 'get',
    params: data,
  });
}

/**
 * @description 用户 -- 签到记录
 */
export function userSignLogApi(uid: number | string, data: any) {
  return request({
    url: `user/sign_log/${uid}`,
    method: 'get',
    params: data,
  });
}

/**
 * @description 用户 -- 浏览足迹
 */
export function userHistoryApi(uid: number | string, data: any) {
  return request({
    url: `user/history/${uid}`,
    method: 'get',
    params: data,
  });
}

/**
 * @description 用户 -- 详情优惠券
 */
export function userCouponApi(uid: number | string, data: any) {
  return request({
    url: `user/coupon/${uid}`,
    method: 'get',
    params: data,
  });
}

/**
 * @description 用户 -- 余额明细
 */
export function userBillApi(uid: number | string, data: any) {
  return request({
    url: `user/bill/${uid}`,
    method: 'get',
    params: data,
  });
}

/**
 * @description 用户 -- 城市列表
 */
export function cityListApi(uid: number | string) {
  return request({
    url: 'system/city/lst',
    method: 'get',
  });
}

/**
 * @description 用户 -- 修改用户推荐人(表单)
 */
export function modifyUserReferrer(uid: number | string) {
  return request({
    url: `user/change_spread_form/${uid}`,
    method: 'get',
  });
}

/**
 * @description 用户 -- 推荐人修改记录
 */
export function modifyUserRefLog(uid: number | string, data: any) {
  return request({
    url: `user/spread_log/${uid}`,
    method: 'get',
    params: data,
  });
}

/**
 * @description 用户 -- 获取协议
 */
export function getAgreementApi(key: string) {
  return request({
    url: `agreement/${key}`,
    method: 'get',
  });
}

/**
 * @description 用户 -- 编辑协议
 */
export function updateAgreementApi(type: string, data: any) {
  return request({
    url: `agreement/${type}`,
    method: 'post',
    data,
  });
}

/**
 * @description 用户搜索信息 -- 列表
 */
export function userSearchLstApi(data: any) {
  return request({
    url: 'user/search_log',
    method: 'get',
    params: data,
  });
}

/**
 * @description 用户搜索信息 -- 导出
 */
export function recordListImportApi(data: any) {
  return request({
    url: 'user/search_log/export',
    method: 'get',
    params: data,
  });
}

/**
 * @description 用户搜索信息 -- 一键清空
 */
export function recordClearApi() {
  return request({
    url: 'user/clear_search_log',
    method: 'get',
  });
}

/**
 * @description 会员管理  -- 添加会员
 */
export function addInterestsApi() {
  return request({
    url: 'user/member/create/form',
    method: 'get',
  });
}

/**
 * @description 会员管理  -- 列表
 */
export function interestsLstApi(data: any) {
  return request({
    url: 'user/member/lst',
    method: 'get',
    params: data,
  });
}

/**
 * @description 会员管理  -- 编辑
 */
export function interestsUpdateApi(id: number | string) {
  return request({
    url: `user/member/update/${id}/form`,
    method: 'get',
  });
}

/**
 * @description 会员管理 -- 删除
 */
export function interestsDeleteApi(id: number | string) {
  return request({
    url: `user/member/delete/${id}`,
    method: 'delete',
  });
}

/**
 * @description 会员 -- 说明
 */
export function interestsInfo(key: string) {
  return request({
    url: `agreement/${key}`,
    method: 'get',
  });
}

/**
 * @description 会员管理 -- 编辑
 */
export function interestsUpdate(key: string, data: any) {
  return request({
    url: `agreement/${key}`,
    method: 'post',
    data,
  });
}

/**
 * @description 会员 -- 配置
 */
export function interestsConfig(key: string) {
  return request({
    url: `config/${key}`,
    method: 'get',
  });
}

/**
 * @description 会员权益  -- 添加
 */
export function addBenefitsApi() {
  return request({
    url: 'member/interests/create/form',
    method: 'get',
  });
}

/**
 * @description 会员权益  -- 列表
 */
export function benefitsLstApi(data: any) {
  return request({
    url: 'member/interests/lst',
    method: 'get',
    params: data,
  });
}

/**
 * @description 会员权益  -- 编辑
 */
export function benefitsUpdateApi(id: number | string) {
  return request({
    url: `/member/interests/update/${id}/form`,
    method: 'get',
  });
}

/**
 * @description 会员权益 -- 删除
 */
export function benefitsDeleteApi(id: number | string) {
  return request({
    url: `member/interests/delete/${id}`,
    method: 'delete',
  });
}

/**
 * 获取版权信息
 * @returns
 */
export function getVersion() {
  return request({
    url: '../api/version',
    method: 'get',
  });
}

/**
 * @description 会员类型  -- 添加
 */
export function levelCreateApi() {
  return request({
    url: 'user/svip/type/form',
    method: 'get',
  });
}

/**
 * @description 会员类型  -- 编辑
 */
export function levelUpdateApi(id: number | string) {
  return request({
    url: `user/svip/type/${id}/form`,
    method: 'get',
  });
}

/**
 * @description 会员类型  -- 删除
 */
export function levelDeteleApi(id: number | string) {
  return request({
    url: `user/svip/type/delete/${id}`,
    method: 'delete',
  });
}

/**
 * @description 付费会员权益 -- 权益状态
 */
export function levelStatusApi(id: number | string, status: number) {
  return request({
    url: `user/svip/type/status/${id}`,
    method: 'post',
    data: { status },
  });
}

/**
 * @description 付费会员类型  -- 列表
 */
export function levelListApi() {
  return request({
    url: 'user/svip/type/lst',
    method: 'get',
  });
}

/**
 * @description 付费会员权益  -- 列表
 */
export function memberEquityListApi() {
  return request({
    url: 'svip/interests/lst',
    method: 'get',
  });
}

/**
 * @description 付费会员权益  -- 编辑表单
 */
export function memberEquityUpdateApi(id: number | string) {
  return request({
    url: `svip/interests/${id}/form`,
    method: 'get',
  });
}

/**
 * @description 付费会员权益 -- 权益状态
 */
export function memberEquityStatusApi(id: number | string, status: number) {
  return request({
    url: `svip/interests/status/${id}`,
    method: 'post',
    data: { status },
  });
}

/**
 * @description 付费会员记录  -- 列表
 */
export function memberRecordListApi(data: any) {
  return request({
    url: 'user/svip/order_lst',
    method: 'get',
    params: data,
  });
}

/**
 * @description 用户  -- 赠送付费会员
 */
export function giveMemberApi(id: number | string) {
  return request({
    url: `user/svip/${id}/form`,
    method: 'get',
  });
}

/**
 * @description 用户设置  -- 列表
 */
export function settingUser() {
  return request({
    url: 'user/info/lst',
    method: 'get',
  });
}

/**
 * @description 用户设置  -- 新增信息
 */
export function addSetting(data: any) {
  return request({
    url: 'user/info/create',
    method: 'post',
    data,
  });
}

/**
 * @description 用户设置  -- 新增信息表单
 */
export function addSettingForm() {
  return request({
    url: 'user/info/create_from',
    method: 'get',
  });
}

/**
 * @description 用户设置  -- 保存
 */
export function setUser(data: any) {
  return request({
    url: 'user/info/save_all',
    method: 'post',
    data,
  });
}

/**
 * @description 用户设置  -- 删除表格
 */
export function userSetDelApi(id: number | string) {
  return request({
    url: `user/info/delete/${id}`,
    method: 'delete',
  });
}

/**
 * @description 用户设置  -- 获取登录注册信息 3.4 待删除
 */
export function userlogInfoApi(key: string) {
  return request({
    url: `config_classify/${key}`,
    method: 'get',
  });
}

/**
 * @description 用户设置  -- 提交登录注册信息
 */
export function userlogInPost(data: any) {
  return request({
    url: 'user/register/config',
    method: 'post',
    data,
  });
}

/**
 * @description 用户设置  -- 登录注册优惠券信息
 */
export function userlogInCouponApi() {
  return request({
    url: 'user/register/coupon',
    method: 'get',
  });
}

/**
 * @description 用户列表  -- 信息更新
 */
export function extendInfo(uid: number | string) {
  return request({
    url: `user/fields/save_form/${uid}`,
    method: 'get',
  });
}

/**
 * @description 用户列表  -- 导出
 */
export function exportUserApi(data: any) {
  return request({
    url: 'user/excel',
    method: 'post',
    data,
  });
}

/**
 * @description 用户列表  -- 编辑
 */
export function userEditApi(id: number | string, data: any) {
  return request({
    url: `user/update/${id}`,
    method: 'post',
    data,
  });
}

/**
 * @description 用户列表  -- 会员等级下拉
 */
export function userMemberListApi() {
  return request({
    url: 'user/member_select_list',
    method: 'get',
  });
}

/**
 * @description 用户列表  -- 信息补充搜索
 */
export function userInfoSelectApi() {
  return request({
    url: 'user/info/select_list',
    method: 'get',
  });
}

/**
 * @description 付费会员记录  -- 数据统计
 */
export function memberRecordCard(data: any) {
  return request({
    url: 'user/svip/count_info',
    method: 'get',
    params: data,
  });
}

/**
 * @description 用户详情  -- 用户成长值
 */
export function memberGrowthLog(data: any) {
  return request({
    url: 'user/member_log',
    method: 'get',
    params: data,
  });
}

/**
 * @description 用户筛选  -- 搜索项
 */
export function userSearchTerms() {
  return request({
    url: '/user/filters',
    method: 'get',
  });
}

/**
 * @description 用户筛选 -- 搜索类型
 */
export function userSearchTypes(key: string) {
  return request({
    url: `/user/search/${key}`,
    method: 'get',
  });
}


//3.4
/**
 * @description 用户筛选 -- 搜索类型
 */
export function userTopApi(data: any) {
    return request({
        url:`/analytics/user/top`,
        method: 'get',
        params: data,
    });
}

/**
 * @description 用户统计 -- 用户折线图
 */
export function userLineChartApi(data: any) {
    return request({
        url: `analytics/user/line_chart`,
        method: 'get',
        params: data,
    });
}

/**
 * @description 用户统计 -- 用户柱状图
 */
export function userPieChartApi(data: any) {
    return request({
        url: `analytics/user/pie_chart`,
        method: 'get',
        params: data,
    });
}

